import React from "react";
import { useParams, useLoaderData } from "react-router-dom";
import { Stack, Button, Box, TextField } from "@mui/material";
import { FullPagePaperLayout } from "../Layouts/FullPagePaperLayout";
import { PageBreadcrumbs, PageTitle, PageSubtitle } from "../Layouts/components/PageTitleContainer";
import { LocationManagementLocationKind } from "types/locationManagement/locationKind";
import { FieldControl } from "components/Form/FieldControl";
import { Form } from "components/Form/Form";

const LocationKindForm: React.FC = () => {
  const { locationKindId } = useParams<{ locationKindId?: string }>();
  const isEdit = Boolean(locationKindId);
  const { locationKind } = useLoaderData() as { locationKind: LocationManagementLocationKind };

  return (
    <FullPagePaperLayout>
      <PageBreadcrumbs links={[{ label: "Admin" }, { label: "Location Kinds", path: "/location-kinds" }]} />
      <PageTitle>{isEdit ? "Edit" : "Create"} Location Kind</PageTitle>
      <PageSubtitle>Name what the location is. Example: Rack, Tote, Gaylord.</PageSubtitle>
      <Box sx={{ m: 3 }}>
        <Form method={isEdit ? "PUT" : "POST"} resource="locationKind">
          <Stack direction="column" spacing={2}>
            <FieldControl
              name="name"
              label="Name"
              inputProps={{ defaultValue: locationKind.name }}
              required
              component={TextField}
            />
            <div>
              <Button type="submit" variant="contained">
                {isEdit ? "Update" : "Create"}
              </Button>
            </div>
          </Stack>
        </Form>
      </Box>
    </FullPagePaperLayout>
  );
};

export default LocationKindForm;
